<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save">
        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field
                    prepend-icon="expand-all"
                    name="nombre"
                    v-model="form.nombre"
                    :label="$t('recargo.labels.nombre')"
                    :placeholder="$t('recargo.labels.nombre')"
                    :error="hasInputErrors('nombre')"
                    :error-messages="getInputErrors('nombre')"
                    color="secondary"
                    :rules="required"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field
                    prepend-icon="expand-all"
                    name="recargo"
                    v-model.number="form.recargo"
                    type="number"
                    :label="$t('recargo.labels.recargo')"
                    :placeholder="$t('recargo.labels.recargo')"
                    :error="hasInputErrors('recargo')"
                    :error-messages="getInputErrors('recargo')"
                    color="secondary"
                    :rules="required"
                ></v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { InputErrorsByProps, RequiredRule } from '@dracul/common-frontend';

export default {
    name: "RecargoForm",
    mixins: [InputErrorsByProps, RequiredRule],

    props: {
        value: {
            type: Object,
            required: true
        }
    },

    data() {
        return {};
    },

    computed: {
        form: {
            get() { return this.value; },
            set(val) { this.$emit('input', val); }
        }
    },

    watch: {
        form: {
            handler(newVal) {
                this.$emit('input', newVal);
            },
            deep: true
        }
    },

    methods: {
        validate() {
            return this.$refs.form.validate();
        }
    }
};
</script>

<style scoped>

</style>
